<template>
  <NavBar />
  <main class="d-flex flex-nowrap">

    <div class="container pt-5">
      <div class="row">
        <div class="col">
          <h1>
            About Us
          </h1>
          <span>이곳은 고객의 about us 화면입니다.</span>
        </div>
      </div>
      <div class="row">
        <div id="parcel-form" class="col mt-3">

          about us 내용이 들어가는 곳

        </div>
      </div>
    </div>
  </main>
</template>

<script>
import NavBar from "@/components/customer/NavBar.vue"

export default {
  name: "About-us",
  components: {
    NavBar,
  },
  data() {
    return {

    }
  },
  methods: {

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
